import { createSlice } from '@reduxjs/toolkit'
import { RootState } from "../../store";
import { IPlayerConfig } from "models/player-config.model";


export interface PlayerState {
    value: IPlayerConfig | undefined;
}

const initialState: PlayerState = {
    value: undefined,
}

export const playerSlice = createSlice({
    name: 'player',
    initialState,
    reducers: {
        initPlayer: (state, action) => {
            state.value = action.payload
        },
    }
});

export const { initPlayer } = playerSlice.actions;
export const playerStoreValue = (state: RootState) => state.playerConfig.value;

export default playerSlice.reducer
